import { getPhone } from './getPhone.js';
import { isDuplicatePhone } from './isDuplicatePhone.js';

/**
 * Merges phone numbers from a department into a location.
 *
 * @param {WidgetLocation} location - The location to merge phone numbers into
 * @param {ADDDepartment} department - The department containing phone numbers
 * @returns {boolean} - Returns true if any phone numbers were merged, false otherwise
 */
export const mergePhones = (location, department, defaultPhone) => {
	const dptPhone = getPhone(department) || defaultPhone;

	if (!dptPhone) {
		return false;
	}

	if (isDuplicatePhone(location.phones, dptPhone)) {
		return false;
	}

	location.phones.push({
		number: dptPhone,
		type: department.label || 'default'
	});

	return true;
};
